/**
 * Icon Component for SVG icons
 * 
 * This component renders SVG icons from the icon library with configurable
 * size, scale, and styling based on state and usage.
 */

import React, { useMemo } from 'react';
import styled from 'styled-components';
import icons from 'globalConstants/Icons';
import { iconThemes } from 'globalConstants/Themes';
import { IconProps } from 'types/components/atoms';

// Interface for SVGWrapper props
interface SVGWrapperProps {
  size: string | number;
  transform: string;
  className?: string;
}

// Styled SVG wrapper for consistent icon rendering
const SVGWrapper = styled.svg.attrs<SVGWrapperProps>(props => ({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50",
  transform: props.transform
}))<SVGWrapperProps>`
  height: ${props => props.size};
  min-width: ${props => props.size}
`;

/**
 * Icon component
 * 
 * @param props - Component props
 * @returns An SVG icon with configurable size and appearance
 */
const Icon: React.FC<IconProps> = ({ state, icon, size, scale = 1, usage }) => {
  const Icon = useMemo(() => icons[icon], [icon]);
  
  return (
    <SVGWrapper className={icon} size={size} transform={`scale(${scale})`} >
      <Icon state={iconThemes[state]} center={false}/>
    </SVGWrapper>
  );
};

export type { IconProps };
export default Icon;
